<template>
  <div id="id-video-share">
    <div class="mask"></div>
    <div class="video-container">
      <div id="id-qplayer-video"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  data () {
    return {
      // 播放器
      player: null
    }
  },
  mounted () {
    console.log('动态路由参数', this.$route.params)
    console.log('####### 视频')
    this.qPlayer()
    console.log('######## 结束')
  },
  methods: {
    qPlayer () {
      let url = null
      switch (this.$route.params.videoName) {
        case 'getUDID':
          url = require('../../assets/video/getUDID.mp4')
          break
        case 'invest':
          url = require('../../assets/video/invest.mp4')
          break
        case 'login':
          url = require('../../assets/video/login.mp4')
          break
        case 'logon':
          url = require('../../assets/video/logon.mp4')
          break
        case 'subscription':
          url = require('../../assets/video/subscription.mp4')
          break
        case '下载测试版APP指引（iOS）':
          url = require('../../assets/video/下载测试版APP指引（iOS）.mp4')
          break
        case '无基金账户-注册、登录、开户':
          url = require('../../assets/video/无基金账户-注册、登录、开户.mp4')
          break
        case '买货币基金':
          url = require('../../assets/video/买货币基金.mp4')
          break
        case '买新基':
          url = require('../../assets/video/买新基.mp4')
          break
        case '下载测试版APP指引（Android）':
          url = require('../../assets/video/下载测试版APP指引（Android）.mp4')
          break
        case '下载测试版APP指引（iOS-test）':
          url = require('../../assets/video/下载测试版APP指引（iOS-test）.mp4')
          break
      }
      // todo 七牛云的 sdk 基本引入
      // eslint-disable-next-line no-new
      this.player = new QPlayer({
        url,
        container: document.getElementById('id-qplayer-video'),
        autoplay: true

        // defaultViewConfig: {
        // }
      })

      this.player.toggleMute()
    }
  }
}
</script>
<style
  lang="scss"
  scoped
>
#id-video-share {
  width: 100vw;
  height: 100vh;

  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    //background-color: #000;
    background-color: #000000;
    //opacity: 0.7;
    z-index: -1;
  }
  .video-container {
    width: 100vw;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    #id-qplayer-video {
      width: 100vw;
      height: 5.707rem;
      //background-color: pink;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/videoPlayer.vue